/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const ONE_MINUTE_WAIT = 60000;
export const DEFAULT_DEBOUNCED_WAIT = 700;
